import _ from 'lodash';
import { useStore } from 'react-redux';
import { ScreenStackState } from '../features/screenStackSlice';
import { useAppSelector } from '../app/hooks';


export default function useJobMenuUrlQuery() {
  const selectorScreenStack = useAppSelector(x => x.screenStack);
  const store = useStore();

  function hasOpenedScreenStartingWithUrl(queryUrl:string) {
    const storeScreenStack = store.getState().screenStack as ScreenStackState;
    const screenStack = storeScreenStack ? storeScreenStack : selectorScreenStack;

    return !!queryUrl &&
      _.keys(screenStack).some(operation => screenStack[operation].findIndex(x => x.url && x.url.toLowerCase().startsWith(queryUrl.toLowerCase())) >= 0);
  }

  return hasOpenedScreenStartingWithUrl;
}
  